import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Typefinders } from '../../../../../core/entities/typefinders.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsTypefindersComponent } from './dialogs-typefinders/edit-dialogs-typefinders/edit-dialogs-typefinders.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { DialogsPermissionsComponent } from '../../../../../shared/components/dialogs/dialogs-permissions/dialogs-permissions.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-typefinders',
  templateUrl: './typefinders.component.html',
  styleUrls: ['./typefinders.component.scss']
})
export class TypefindersComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  typefinder: Typefinders = new Typefinders();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllTypefinders();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla typefinders
  */
  private getAllTypefinders(): void {
    this.loading = true;
    this.internalHomeService.allTypefinders().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un typefinder
  * @param typefinder Opcional. Typefinder vacio.
  */
  public createTypefinder(typefinder?: Typefinders) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    typefinder = this.typefinder;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsTypefindersComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { typefinder, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllTypefinders();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un typefinder
  * @param typefinder Opcional. Typefinder a editar. Si vamos a crear será undefined
  */
  public editTypefinder(typefinder?: Typefinders) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "70%";
    const dialogRef = this.dialog.open(EditDialogsTypefindersComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { typefinder, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllTypefinders();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un typefinder
  * @param typefinder Typefinder a eliminar
  */
  public removeTypefinder(typefinder?: Typefinders) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_typefinders') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeTypefinders(typefinder).subscribe(res => {
          console.log(res);
          this.getAllTypefinders();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para modificar permisos de un typefinder
  * @param typefinder Permiso Typefinder a editar
  */
  public permissionTypefinder(typefinder?: Typefinders){
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let clasepermisos = this.translateService.instant('TABLAS.typefinder');
    let objectpermisos;
    let idpermisos;
    if(typefinder){
      objectpermisos = typefinder.code;
      idpermisos = typefinder.id;
    }
    const dialogRef = this.dialog.open(DialogsPermissionsComponent, {
      width: '85%',
      disableClose: true,
      hasBackdrop: true,
      data: { typefinder, titulochange, clasepermisos, objectpermisos, idpermisos }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: Typefinders) => {
      Utils.toggleAllButtonsAndHref(false);
      console.log(result);
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
